import React, { useEffect, useState } from 'react';
import { BookOpenIcon, ClipboardListIcon, UtensilsIcon, ShoppingCartIcon, GiftIcon, ArrowRightIcon } from 'lucide-react';
const items = [{
  icon: <BookOpenIcon className="text-coral" size={28} data-id="element-263" />,
  title: "Ebook Principal 'Reinicia tu Metabolismo'",
  desc: 'La teoría explicada de forma simple. Todo lo que necesitás saber.',
  value: 15000
}, {
  icon: <ClipboardListIcon className="text-sage" size={28} data-id="element-264" />,
  title: 'Plan de 21 Días paso a paso',
  desc: 'Qué hacer cada día. Sin adivinanzas, 100% práctico.',
  value: 8000
}, {
  icon: <UtensilsIcon className="text-warm-brown" size={28} data-id="element-265" />,
  title: '40+ Recetas antiinflamatorias',
  desc: 'Comidas deliciosas, fáciles de preparar y con ingredientes locales.',
  value: 6000
}, {
  icon: <ShoppingCartIcon className="text-coral-dark" size={28} data-id="element-266" />,
  title: 'Lista de compras semanal',
  desc: 'Ahorrá tiempo y dinero en el supermercado.',
  value: 3000
}, {
  icon: <GiftIcon className="text-rose" size={28} data-id="element-267" />,
  title: 'BONUS: Guía de snacks saludables',
  desc: 'Para esos momentos de ansiedad a media tarde.',
  value: 4000
}, {
  icon: <GiftIcon className="text-rose" size={28} data-id="element-268" />,
  title: 'BONUS: Meditaciones para ansiedad',
  desc: 'Audios cortos para calmar la mente y bajar el cortisol.',
  value: 5000
}];
export function WhatsIncluded() {
  const totalValue = items.reduce((acc, item) => acc + item.value, 0);
  const offerPrice = 14999;
  const [spots, setSpots] = useState(14);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpots(prev => prev > 11 ? prev - 1 : prev);
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-20 bg-white" id="comprar" data-id="element-269">
      <div className="container mx-auto px-4 max-w-5xl fade-in-section" data-id="element-270">
        <div className="text-center mb-12" data-id="element-271">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-272">
            ¿Qué incluye tu programa?
          </h2>
          <p className="text-lg text-text-medium" data-id="element-273">
            Todo lo que necesitás para tener éxito, en un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-274">
          {items.map((item, index) => <div key={index} className="flex bg-bg-warm p-6 rounded-2xl border border-beige-dark hover:border-coral/30 transition-colors" data-id="element-275">
              <div className="flex-shrink-0 mr-4 mt-1" data-id="element-276">{item.icon}</div>
              <div className="flex-1" data-id="element-277">
                <h4 className="text-lg font-bold text-text-dark mb-1" data-id="element-278">
                  {item.title}
                </h4>
                <p className="text-sm text-text-medium mb-2" data-id="element-279">{item.desc}</p>
                <p className="text-sm font-semibold text-coral" data-id="element-280">
                  Valor: ${item.value.toLocaleString('es-AR')}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-4" data-id="element-281">
          <span className="inline-flex items-center gap-2 bg-rose/10 text-coral-dark font-bold px-4 py-2 rounded-full text-sm border border-rose/20" data-id="element-282">
            <span className="relative flex h-2 w-2" data-id="element-283">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-coral opacity-75" data-id="element-284"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-coral" data-id="element-285"></span>
            </span>
            🔥 Solo quedan {spots} lugares al precio promocional
          </span>
        </div>

        <div className="bg-gradient-to-br from-blush to-beige p-8 md:p-12 rounded-3xl shadow-card text-center max-w-3xl mx-auto border border-rose/20 relative overflow-hidden" data-id="element-286">
          <div className="absolute top-0 right-0 bg-coral text-white text-xs font-bold px-4 py-1 rounded-bl-lg animate-pulse-soft" data-id="element-287">
            OFERTA LIMITADA
          </div>

          <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-288">
            Resumen de tu inversión
          </h3>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-289">
            <p className="text-lg text-text-medium line-through mb-2" data-id="element-290">
              Valor total: ${totalValue.toLocaleString('es-AR')}
            </p>
            <div className="flex items-baseline justify-center gap-2" data-id="element-291">
              <span className="text-2xl font-bold text-text-dark" data-id="element-292">Hoy:</span>
              <span className="text-5xl md:text-6xl font-black text-coral drop-shadow-sm" data-id="element-293">
                ${offerPrice.toLocaleString('es-AR')}
              </span>
            </div>
            <p className="text-sm text-sage font-bold mt-2" data-id="element-294">
              Pago único. Acceso de por vida.
            </p>
          </div>

          <a href="https://reiniciatumetabolismo.lat/cart/43809396064391:1?checkout" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-bold text-white bg-coral rounded-full shadow-cta hover:bg-coral-dark transition-all duration-300 animate-pulse-soft w-full" data-id="element-295">
            Quiero todo esto por solo ${offerPrice.toLocaleString('es-AR')}
            <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-transform" size={24} data-id="element-296" />
          </a>

          <p className="text-sm text-text-medium mt-4 font-medium" data-id="element-297">
            88% de descuento · Precio válido solo por hoy · Pago único
          </p>
        </div>
      </div>
    </section>;
}